import { render } from "./MySales.vue?vue&type=template&id=20bb7c82"
import script from "./MySales.vue?vue&type=script&lang=js"
export * from "./MySales.vue?vue&type=script&lang=js"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__